<template>
  <el-row class="white-space" :style="{height: `${size}px`}" ></el-row>
</template>

<script>
export default {
  props: {
    size: Number
  }
}
</script>

<style lang="scss">
// .white-space {
//   height: 70px;
// }
</style>



// WEBPACK FOOTER //
// src/components/WhiteSpace.vue